import { useCallback } from 'react';

import { HEADER_HEIGHT } from '../hybrid-search-page-layout';
import { useListingLayoutIsNarrowSelector } from '../redux-state/store/slices/listingLayout';
import { scrollToTopWithCallback } from '../utils';

export const useScrollToTopWithCallback = (): ((fn: VoidFunction) => void) => {
  const isNarrow = useListingLayoutIsNarrowSelector();

  return useCallback((fn: VoidFunction) => scrollToTopWithCallback(fn, isNarrow ? HEADER_HEIGHT : 0), [isNarrow]);
};
